import { getSettingValueAndAssign, getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { ENABLE_EXPERIMENTAL_LOGIN_LATENCY_INTERVENTIONS_240119 } from "@faire/web-api--source/indigofair/settings/ENABLE_EXPERIMENTAL_LOGIN_LATENCY_INTERVENTIONS_240119";
import { EXPERIMENTAL_HCAPTCHA_FRONTEND_TIMEOUT_MS } from "@faire/web-api--source/indigofair/settings/EXPERIMENTAL_HCAPTCHA_FRONTEND_TIMEOUT_MS";
import { HCAPTCHA_FRONTEND_TIMEOUT_MS } from "@faire/web-api--source/indigofair/settings/HCAPTCHA_FRONTEND_TIMEOUT_MS";
export var getSettingHCaptchaTimeoutMS = function() {
    return getSettingValueWithoutAssignment(HCAPTCHA_FRONTEND_TIMEOUT_MS, 1000);
};
export var getSettingAndAssignEnableExperimentalLoginLatencyInterventions = function() {
    return getSettingValueAndAssign(ENABLE_EXPERIMENTAL_LOGIN_LATENCY_INTERVENTIONS_240119, false);
};
export var getSettingExperimentalHCaptchaTimeoutMS = function() {
    return getSettingValueWithoutAssignment(EXPERIMENTAL_HCAPTCHA_FRONTEND_TIMEOUT_MS, 1000);
};
